(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('BagService', BagService);

    function BagService($rootScope, $localStorage, $window, toastr, $translate,
                        CustomerService, ModalFactory, ShowcasesService) {
        var service = {
            getBagUrl: getBagUrl,
            sendToWhatsApp: sendToWhatsApp,
            getBagWhatsAppText: getBagWhatsAppText
        };

        return service;

        function getBagUrl(bag) {
            var redirectUrl = $localStorage.defaultStore.storeInfo.redirectUrl;
            if (redirectUrl) {
                return $window.location.protocol + '//' + redirectUrl + '/bag/' + bag.id;
            } else {
                var storeNickname = $localStorage.defaultStore.storeInfo.nickname;
                var storeType = $localStorage.defaultStore.storeInfo.storeType;
                return $window.location.protocol + '//' + storeNickname + '.' + getDomainNameSufix($window, storeType) + '/bag/' + bag.id;
            }
        }

        function sendToWhatsApp(bag) {
            if (bag.customers && bag.customers.length > 0) {
                var customerId = bag.customers[0];
                if (customerId) {
                    // get customer by Id from CustomerService
                    CustomerService.getById(customerId).then(function (customer) {
                        var phone = customer.data.phone;
                        if (phone) {
                            var url = 'https://api.whatsapp.com/send/?phone=' + phone + '&text=' + encodeURIComponent(getBagWhatsAppText(bag));
                            $window.open(url, '_blank');
                        } else {
                            toastr.error($translate.instant('bag.error.no-phone'));
                        }
                    }, function (error) {
                        toastr.error($translate.instant('bag.error.customer-not-found'));
                    });
                }
            } else {
                var url = 'https://api.whatsapp.com/send/?text=' + encodeURIComponent(getBagWhatsAppText(bag));
                $window.open(url, '_blank');
            }
        }

        function getBagWhatsAppText(bag) {
            return $translate.instant('bag.actions.whatsapp-text', { whatsappUrl: getBagUrl(bag) });
        }
    }
})();
